var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"layout"}},[_c('el-container',[_c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('layoutHeader'),_c('el-container',[_c('router-view')],1),_c('layoutFooter')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }